import { Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CIVILITES_CONTACT } from '../../../core/models/contact.model';
import {
  DUREE_BAIL_UNITES,
  DureeBailUnite,
} from '../../../core/models/locataire-bail.model';
import {
  formatLogementChoiceLabel,
  Logement,
} from '../../../core/models/logement.model';
import { I18nValuePipe } from '../../../core/pipes/i18n-value.pipe';
import { HelpTipComponent } from '../../../shared/help-tip/help-tip.component';

/**
 * Champs partagés du formulaire locataire (création / édition).
 */
@Component({
  selector: 'app-locataire-form-fields',
  templateUrl: './locataire-form-fields.component.html',
  styleUrls: ['./locataire-form-fields.component.css'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    I18nValuePipe,
    HelpTipComponent,
  ],
})
export class LocataireFormFieldsComponent {
  @Input({ required: true }) form!: FormGroup;
  @Input() logements: Logement[] = [];
  @Input() selectedMeuble = false;
  @Input() dureeBailHintKey = '';
  @Input() dureeBailErrorKey = '';
  @Input() dureeBailInvalid = false;

  readonly civilites = CIVILITES_CONTACT;
  readonly dureeUnites: readonly DureeBailUnite[] = DUREE_BAIL_UNITES;

  constructor(private readonly translate: TranslateService) {}

  get logementId(): string {
    return String(this.form.get('logementId')?.value ?? '');
  }

  optionLabel(logement: Logement): string {
    return formatLogementChoiceLabel(logement, (key) =>
      this.translate.instant(key)
    );
  }
}
